/**
 * Table geometry shared by the server (which picks the bottle angle) and the Mini App (which draws seats).
 * Angles are in degrees, clockwise, 0 = 12 o'clock. Seat 0 sits at the top; seats continue clockwise.
 */

export function seatAngle(seat: number, capacity: number): number {
  return normalizeAngle((360 / capacity) * seat);
}

export function normalizeAngle(deg: number): number {
  const a = deg % 360;
  return a < 0 ? a + 360 : a;
}

/**
 * Final absolute bottle angle for a spin that must stop pointing at `targetSeat`.
 * The bottle always turns forward (clockwise) at least `minTurns` full rotations from `fromAngle`,
 * and lands inside the target's sector with a small random offset (`jitter` in [-1, 1]) so spins look natural.
 */
export function spinAngle(
  fromAngle: number,
  targetSeat: number,
  capacity: number,
  extraTurns: number,
  jitter: number,
  minTurns = 3,
): number {
  const sector = 360 / capacity;
  const target = seatAngle(targetSeat, capacity) + jitter * sector * 0.3;
  const from = normalizeAngle(fromAngle);
  let delta = normalizeAngle(target - from);
  delta += 360 * (minTurns + extraTurns);
  return fromAngle + delta;
}

/** Seat the bottle points at for an absolute angle (inverse of spinAngle, used by tests and the client). */
export function seatAtAngle(angle: number, capacity: number): number {
  const sector = 360 / capacity;
  return Math.round(normalizeAngle(angle) / sector) % capacity;
}
